import { render, staticRenderFns } from "./InheritText.vue?vue&type=template&id=c275a3d0"
import script from "./InheritText.vue?vue&type=script&lang=js"
export * from "./InheritText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports